// Submission status at `/status/$trackingId`. Structure from Figma Make's
// StatusPage — 4 stages (Подаден → Платен → Фактуриран → Публикуван) with
// timestamps. Each stage is a row inside a single Card with status pill
// left, label + detail center, timestamp right.
//
// TODO: wire loader to fetch tracking state from backend.

import { Card, CardContent, CardHeader, CardTitle, H1, P, Separator } from '@podium/platform/ui'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/status/$trackingId')({
  component: StatusPage,
})

type StageStatus = 'completed' | 'in_progress' | 'pending'

type Stage = {
  label: string
  status: StageStatus
  timestamp: string | null
  detail?: string
}

const STATUS_META: Record<StageStatus, { label: string; className: string }> = {
  completed: {
    label: 'Завършен',
    className: 'bg-primary text-primary-foreground',
  },
  in_progress: {
    label: 'В процес',
    className: 'bg-accent text-accent-foreground',
  },
  pending: {
    label: 'Предстои',
    className: 'bg-muted text-muted-foreground',
  },
}

function StatusPage() {
  const { trackingId } = Route.useParams()

  // TODO: replace with loader data.
  const stages: Stage[] = [
    { label: 'Подаден', status: 'pending', timestamp: null },
    { label: 'Платен', status: 'pending', timestamp: null },
    { label: 'Фактуриран', status: 'pending', timestamp: null },
    { label: 'Публикуван', status: 'pending', timestamp: null },
  ]

  return (
    <div className="mx-auto max-w-3xl px-6 py-8">
      <div className="mb-6 space-y-2">
        <H1>Статус на подаването</H1>
        <P className="text-muted-foreground">
          Референтен номер:{' '}
          <span className="font-mono font-medium text-foreground">{trackingId}</span>
        </P>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Етапи на публикуването</CardTitle>
        </CardHeader>
        <CardContent className="space-y-0">
          {stages.map((stage, i) => (
            <div key={stage.label}>
              {i > 0 && <Separator />}
              <div className="flex flex-col gap-2 py-3 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex items-center gap-3">
                  <span
                    className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${STATUS_META[stage.status].className}`}
                  >
                    {STATUS_META[stage.status].label}
                  </span>
                  <div>
                    <P
                      className={
                        stage.status === 'pending'
                          ? 'font-medium text-muted-foreground'
                          : 'font-medium'
                      }
                    >
                      {stage.label}
                    </P>
                    {stage.detail && (
                      <P className="text-xs text-muted-foreground">{stage.detail}</P>
                    )}
                  </div>
                </div>
                <P className="text-sm text-muted-foreground">{stage.timestamp ?? '—'}</P>
              </div>
            </div>
          ))}
        </CardContent>
      </Card>

      <P className="mt-6 text-sm text-muted-foreground">
        Ако имате въпрос по подаването, свържете се с нас на{' '}
        <a href="mailto:office@godishni-otcheti.com">office@godishni-otcheti.com</a> и посочете
        референтния номер.
      </P>
    </div>
  )
}
